import {getField, updateField} from 'vuex-map-fields';
import StoreFile from '@/commonFunction/baseTableModule'

let instance = new StoreFile('/ws/store_file/');

const state = {
    ...instance.state,
    columns: [
        // {text: '', value: 'task_id', sortable: false, divider: true, width: 50, brief:true,},
        {text: '', value: 'actions', sortable: false, divider: true, width: 80, brief: true,},
        // {text: 'Task status', value: 'task_status', sortable: false, filterable: true, divider: true, brief:true,},
        {
            text: 'Angebot ID (Title)',
            value: 'title',
            sortable: true,
            filterable: true,
            divider: true,
            brief: true,
        },
        {
            text: 'Baugruppe (Variants)',
            value: 'variants_list',
            sortable: false,
            filterable: true,
            divider: true,
            brief: true,
        },
        {text: 'Kunde (Customer)', value: 'customer__title', sortable: true, divider: true, brief: true,},
        {text: 'Customer type', value: 'customer__customer_type', sortable: true, divider: true},
        {text: 'Customer priority', value: 'customer__priority', sortable: true, divider: true},
        {
            text: 'Kunden-Aufträge (Customer order)', value: 'customer_order__title', sortable: true,
            divider: true, brief: true,
        },
        {text: 'Bearbeiter (Editors)', value: 'editors_list', sortable: false, divider: true, brief: true,},
        {text: 'Express', value: 'express', sortable: true, divider: true},
        {text: 'Status', value: 'status', sortable: true, divider: true},
        {text: 'Eingangsdatum (Date receipt)', value: 'date_receipt', sortable: true, divider: true},
        {text: 'Ziel Abgabe (Target levy)', value: 'target_levy', sortable: true, divider: true},
        {text: 'Abgabedatum (Submission date)', value: 'submission_date', sortable: true, divider: true},
        {
            text: 'Eingang bestätigt (Receipt confirmed)',
            value: 'receipt_confirmed',
            sortable: true,
            divider: true
        },
        {text: 'Daten gespeichert (Data saved)', value: 'data_saved', sortable: true, divider: true},
        {text: 'Assembly variant', value: 'assembly_variant', sortable: true, divider: true},
        {text: 'Total variations', value: 'total_variations', sortable: true, divider: true},
        {text: 'Losgröße (Lot size)', value: 'lot_size', sortable: true, divider: true},
        {text: 'Mat-Faktor (Food factor)', value: 'food_factor', sortable: true, divider: true},
        {text: 'Gesamtpreise (Total prices)', value: 'total_prices', sortable: true, divider: true},
        {text: 'Material', value: 'material', sortable: true, divider: true},
        {text: 'LP Einkauf (LP purchasing)', value: 'lp_purchasing', sortable: true, divider: true},
        {text: 'EMS', value: 'ems', sortable: true, divider: true},
        {text: 'Hinweis (note)', value: 'note', sortable: true, divider: true},
        {text: 'Richtpreis (Guide price)', value: 'guide_price', sortable: true, divider: true},
        {text: 'Typ (Type)', value: 'typ', sortable: true, divider: true},
        {text: 'Erstellt am (Created on)', value: 'created_on', sortable: true, divider: true},
        {text: 'Letzter Bearbeiter (Last editor)', value: 'last_editor', sortable: true, divider: true},
        {text: 'Zuletzt bearbeitet (Edited on)', value: 'edited_on', sortable: true, divider: true},
        {text: 'Auswertung (Evaluation)', value: 'evaluation', sortable: true, divider: true},
    ],
    briefView: false,
    options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['id'],
                sortDesc: [true],
                multiSort: false,
                mustSort: true,
                descending: true,

            },
    previewLink: [null, null],
};
const getters = {
    ...instance.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...instance.actions,
};
const mutations = {
    ...instance.mutations,
    updateSearchTerm(state, searchTerm) {
        state.searchTerm = searchTerm
    },
    updateSearchTermFile(state, searchTermFile) {
        state.searchTermFile = searchTermFile
    },
    // updateStoreDocItemId(state, storeDocItemId) {
    //     state.storeDocItemId = storeDocItemId
    // },
};

export default {
    modules: {
        StoreFile: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}